import React from "react";
import "./PortfolioDesign.scss";

const PortfolioDesign = () => {
  return (
    <>
      <section className="section portfolioDesign">
        <article className="portfolioDesign__container container">
          <div className="portfolioDesign__container--header">
            <h2>Design</h2>
            <h3>Process</h3>
          </div>
          <div className="portfolioDesign__container--contents">
            <div className="contents__item">
              <p className="num active-num">1</p>
              <h3 className="title">Research</h3>
              <p className="subtitle">
                In the research phase, we comprehensively study user needs,
                behaviors, and pain points through methods like interviews and
                data analysis to inform the design process effectively.
              </p>
            </div>

            <div className="contents__item">
              <p className="num">2</p>
              <h3 className="title">Design</h3>
              <p className="subtitle">
                During the design phase, we create wireframes and prototypes,
                visually conceptualizing solutions. These serve as blueprints
                for the user interface&apos;s structure, layout, and
                functionality.
              </p>
            </div>

            <div className="contents__item">
              <p className="num">3</p>
              <h3 className="title">Testing</h3>
              <p className="subtitle">
                In the testing phase, we gather user feedback on prototypes,
                assess usability, and refine designs. This iterative process
                ensures the final product meets user expectations and needs.
              </p>
            </div>

            <div className="contents__item">
              <p className="num">4</p>
              <h3 className="title">implementation</h3>
              <p className="subtitle">
                In the implementation phase, we focus on translating the
                designed user interface into a functional product, adhering to
                the established design guidelines and aesthetics. -
                implementation
              </p>
            </div>

            <div className="contents__item">
              <p className="num">5</p>
              <h3 className="title">Iteration</h3>
              <p className="subtitle">
                During the iteration phase, we revisit and refine the design and
                functionality based on feedback and insights gathered from user
                testing and evaluation, ensuring continuous improvement
              </p>
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default PortfolioDesign;
